import React from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { ArrowLeft, ScrollText } from "lucide-react";
import LegalFooter from "@/components/LegalFooter";
import { LEGAL_PAGES, LEGAL_CONTENT, COMPANY, EFFECTIVE } from "@/legalContent";

const Block = ({ b }) => {
  if (b.type === "h") return <h2 className="mt-7 font-display text-base font-semibold text-slate-100 md:text-lg">{b.text}</h2>;
  if (b.type === "ul") return <ul className="mt-3 list-disc space-y-1.5 pl-5 text-sm leading-relaxed text-slate-300">{b.items.map((t, i) => <li key={i}>{t}</li>)}</ul>;
  if (b.type === "table") return (
    <div className="mt-3 overflow-x-auto rounded-xl border border-slate-800">
      <table className="w-full text-left text-sm">
        <thead className="bg-slate-900/70 text-xs uppercase tracking-wide text-slate-400"><tr>{b.head.map((h) => <th key={h} className="px-3 py-2 font-semibold">{h}</th>)}</tr></thead>
        <tbody>{b.rows.map((r, i) => <tr key={i} className="border-t border-slate-800 text-slate-300">{r.map((c, j) => <td key={j} className="px-3 py-2 align-top">{c}</td>)}</tr>)}</tbody>
      </table>
    </div>
  );
  return <p className="mt-3 text-sm leading-relaxed text-slate-300">{b.text}</p>;
};

export default function LegalPage() {
  const { slug } = useParams();
  const page = LEGAL_PAGES.find((p) => p.slug === slug);
  if (!page) return <Navigate to="/legal/privacy" replace />;
  return (
    <div data-testid="legal-page" className="grain min-h-screen bg-[#0a0e17] text-slate-100">
      <div className="mx-auto max-w-5xl px-4 py-10 sm:px-6 lg:px-8">
        <Link data-testid="legal-back" to="/" className="inline-flex items-center gap-1.5 text-xs text-slate-400 hover:text-orange-400"><ArrowLeft className="h-3.5 w-3.5" /> Back to R.U.A.C.H.</Link>
        <div className="mt-6 grid gap-8 lg:grid-cols-[220px_1fr]">
          <nav data-testid="legal-nav" className="space-y-1 lg:sticky lg:top-8 lg:self-start">
            {LEGAL_PAGES.map((p) => (
              <Link key={p.slug} data-testid={`legal-nav-${p.slug}`} to={`/legal/${p.slug}`}
                className={`block rounded-lg px-3 py-2 text-sm transition-colors ${p.slug === slug ? "bg-orange-600/15 font-semibold text-orange-300" : "text-slate-400 hover:bg-slate-800/60 hover:text-slate-200"}`}>
                {p.nav}
              </Link>
            ))}
          </nav>
          <article className="rounded-2xl border border-slate-800/80 bg-[#131a2a] p-6 shadow-2xl fade-up sm:p-8">
            <div className="flex items-center gap-2 text-orange-400"><ScrollText className="h-5 w-5" /><span className="text-xs font-semibold uppercase tracking-wider">{COMPANY}</span></div>
            <h1 data-testid="legal-title" className="mt-2 font-display text-3xl font-bold text-slate-100 sm:text-4xl">{page.title}</h1>
            <p className="mt-1 text-xs text-slate-500">Effective {EFFECTIVE}</p>
            {LEGAL_CONTENT[slug].map((b, i) => <Block key={i} b={b} />)}
          </article>
        </div>
      </div>
      <LegalFooter />
    </div>
  );
}
